export interface SwapFeeBpsInput {
  swapGroupBps: number
  swapLpBps: number
  swapValiantBps: number
}

export interface SwapAmountInput extends SwapFeeBpsInput {
  fromAmount: number
  toAmount: number
}

export interface SwapSummaryDisplayInput extends SwapAmountInput {
  fromDecimals: number
  toDecimals: number
  fromSymbol: string
  toSymbol: string
}

export function calculateDisplayFeeBps({
  swapGroupBps,
  swapValiantBps,
}: Pick<SwapFeeBpsInput, 'swapGroupBps' | 'swapValiantBps'>): number {
  return swapGroupBps + swapValiantBps
}

export function calculateLpInclusiveAmountTraded({
  fromAmount,
  swapGroupBps,
  swapValiantBps,
}: Pick<SwapAmountInput, 'fromAmount' | 'swapGroupBps' | 'swapValiantBps'>): number {
  const feeBps = calculateDisplayFeeBps({ swapGroupBps, swapValiantBps })
  return fromAmount - (fromAmount * feeBps) / 10000
}

export function calculateSwapPrice({
  toAmount,
  amountTraded,
}: {
  toAmount: number
  amountTraded: number
}): number {
  return amountTraded > 0 ? toAmount / amountTraded : 0
}

export function buildSwapSummaryDisplay({
  fromAmount,
  toAmount,
  swapGroupBps,
  swapValiantBps,
  fromDecimals,
  toDecimals,
  fromSymbol,
  toSymbol,
}: Pick<SwapSummaryDisplayInput, 'fromAmount' | 'toAmount' | 'swapGroupBps' | 'swapValiantBps' | 'fromDecimals' | 'toDecimals' | 'fromSymbol' | 'toSymbol'>) {
  const amountTraded = calculateLpInclusiveAmountTraded({
    fromAmount,
    swapGroupBps,
    swapValiantBps,
  })
  const price = calculateSwapPrice({ toAmount, amountTraded })
  const priceDecimals = Math.max(toDecimals, 5)

  return {
    fee: calculateDisplayFeeBps({ swapGroupBps, swapValiantBps }),
    amountTraded: Number(amountTraded.toFixed(fromDecimals)).toLocaleString('en-US', {
      minimumFractionDigits: fromDecimals,
      maximumFractionDigits: fromDecimals,
    }),
    amountTradedSymbol: fromSymbol,
    price: price.toFixed(priceDecimals),
    priceSymbol: `${toSymbol}/${fromSymbol}`,
  }
}

export function parseFormattedAmount(amount: string): number {
  return parseFloat(amount.replace(/,/g, ''))
}
